import { BrandingSettings, User } from '@interfaces';

export type UserAuthState = Readonly<{
  loading: boolean;
  myself: null | User;
  errorMessage: string | null;

  loadingBranding: boolean;
  branding: BrandingSettings | null;
}>;

export const initialState: UserAuthState = {
  loading: false,
  myself: null,
  errorMessage: null,

  loadingBranding: false,
  branding: null,
};
